import { default as ReactSelect, components } from "react-select";

interface SelectCheckboxProps {
  label: string;
  name: string;
  value: any;
  onChange: (e: any) => void;
  className?: string;
  fetchOptions: any;
}

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected} // Vérifie si l'option est sélectionnée
        onChange={() => props.selectOption(props.data)}
      />{" "}
      <label>{props.label}</label>
    </components.Option>
  );
};

export function SelectCheckbox({
  label,
  name,
  value,
  onChange,
  fetchOptions,
  className: clasName,
}: SelectCheckboxProps) {
  return (
    <div className={`flex flex-col text-grey mt-2 ${clasName}`}>
      <label className="text-sm font-thin">{label} :</label>
      <ReactSelect
        options={fetchOptions}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        styles={{
          control: (provided) => ({
            ...provided,
            backgroundColor: "white",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            borderColor: "lightblue",
            borderWidth: 2,
            borderRadius: "0.375rem",
            height: "auto",
            minHeight: "2.25rem",
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        components={{ Option }}
        onChange={onChange}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        value={value}
        name={name}
      />
    </div>
  );
}
